// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alarm-events-table__cell{padding-left:1rem !important}", "",{"version":3,"sources":["webpack://./src/components/AlarmsTable/AlarmEventsTable/AlarmEventsTable.scss"],"names":[],"mappings":"AAAA,0BACE,4BAAA","sourcesContent":[".alarm-events-table__cell {\n  padding-left: 1rem!important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
